import { render, staticRenderFns } from "./QuizLoader.vue?vue&type=template&id=53ae9be9&"
import script from "./QuizLoader.vue?vue&type=script&lang=js&"
export * from "./QuizLoader.vue?vue&type=script&lang=js&"
import style0 from "./QuizLoader.vue?vue&type=style&index=0&id=53ae9be9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports